export default __webpack_public_path__ + "static/media/delete.0beded2b.svg";